import { faFileEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { Show } from '../../../../shared/Show';
import { useGetProgressionsQuery } from '../../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { getCurrentSigSyncProgressionStatus } from '../../utilities/getCurrentSigSyncProgressionStatus';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../types/shared/UUID';
import { ISigningAppointmentResponse } from '../../../../../types/signingAppointment/ISigningAppointmentResponse';

export interface ICorrectionsButtonProps {
  secondary?: boolean;
  onCorrectionsButtonClick: (event: any) => void;
  appointment: ISigningAppointmentResponse;
}

export const CorrectionsButton: React.FC<ICorrectionsButtonProps> = ({
  secondary = false,
  onCorrectionsButtonClick,
  appointment,
}) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: progressions } = useGetProgressionsQuery({ id: appointment.id, orderId: orderId });

  const correctionStatus = appointment.isSignatureSyncAppointment
    ? getCurrentSigSyncProgressionStatus(progressions!)?.toLowerCase()
    : appointment.status;

  const isStatusComplete = correctionStatus === 'complete';

  return (
    <Show when={isStatusComplete}>
      <ButtonTW
        secondary={secondary}
        onClick={(event: any) => {
          onCorrectionsButtonClick(event);
        }}
      >
        <FontAwesomeIcon className={'pr-2'} icon={faFileEdit} />
        Create Correction
      </ButtonTW>
    </Show>
  );
};
